import { render, staticRenderFns } from "./WallboxSpecialData.vue?vue&type=template&id=566995f5&scoped=true"
import script from "./WallboxSpecialData.vue?vue&type=script&lang=js"
export * from "./WallboxSpecialData.vue?vue&type=script&lang=js"
import style0 from "./WallboxSpecialData.vue?vue&type=style&index=0&id=566995f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566995f5",
  null
  
)

export default component.exports